import { requestAwardTeamConfig } from 'components/ShiftModal/src/views/AwardTeamMemberView/AwardTeamMemberView.constants';
import { BiddableShiftStatus } from 'components/Tags/Tags.types';
import { useSSFBehaviors, useURLParameters } from 'hooks';
import { FC, MouseEventHandler, useContext, useEffect, useState } from 'react';
import { GQLAPIContextType } from 'types/common.types';
import { FetchOrderBiddersQuery } from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';
import { getShiftBiddingStatus } from 'utils/shiftStatus';
export const AwardTeamMemberContext = createGQLDataContext({});
export const AwardTeamMemberProvider: FC = ({ children }) => {
  const [{ shiftModalShiftId }] = useURLParameters<{ shiftModalShiftId?: string }>();
  const [biddingStatus, setBiddingStatus] = useState<Nullable<BiddableShiftStatus>>(null);

  const [values, { data, ...rest }] = useSSFBehaviors(
    requestAwardTeamConfig({ orderId: Number(shiftModalShiftId) }),
  );

  useEffect(() => {
    if (!!data?.fetchOrder && !biddingStatus) {
      setBiddingStatus(
        getShiftBiddingStatus({
          status: data?.fetchOrder?.status.value,
          biddable: data?.fetchOrder?.biddable,
          biddingTimeEndsAt: data?.fetchOrder?.biddingTimeEndsAt,
          awardingTimeStartsAt: data?.fetchOrder?.awardingTimeStartsAt,
          bidders: data?.fetchOrder?.bidders,
        }),
      );
    }
  }, [biddingStatus, data?.fetchOrder]);

  return (
    <AwardTeamMemberContext.Provider
      value={{
        values,
        data,
        biddingStatus,
        ...rest,
      }}
    >
      {children}
    </AwardTeamMemberContext.Provider>
  );
};

export const useAwardTeamMemberContext = (): GQLAPIContextType<FetchOrderBiddersQuery> & {
  onReset: MouseEventHandler<HTMLDivElement>;
  data: FetchOrderBiddersQuery;
  biddingStatus: Nullable<BiddableShiftStatus>;
} => useContext(AwardTeamMemberContext);
